import React, { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { Card } from "antd";
import PropTypes from "prop-types";

const Widget = ({ title, children, styleName, cover, extra, actions }) => {
  const [styleValue, setStyleValue] = useState("");
  const [classValue, setClassValue] = useState("");

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1260px)" });
  const isTabletOrMobileDevice = useMediaQuery({
    query: "(max-device-width: 1224px)",
  });

  const cardWidth = isTabletOrMobile ? "90%" : "300px";

  const cardStyles = {
    width: cardWidth,
    marginBottom: "10px",
    marginLeft: isDesktopOrLaptop ? "3%" : "4%",
    marginTop: isDesktopOrLaptop ? 0 : "1%",
  };

  return (
    <Card
      style={cardStyles}
      className={`gx-card-widget ${styleName} col gx-col-full col-md-6 col-sm-6 col-xs-6 col-xl-6`}
    >
      {children}
    </Card>
  );
};

export default Widget;
Widget.defaultProps = {
  styleName: "",
};

Widget.propTypes = {
  title: PropTypes.node,
  extra: PropTypes.node,
  cover: PropTypes.node,
  actions: PropTypes.node,
  children: PropTypes.node.isRequired,
};
